
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPreset/addPage/pagePreview/multiplePresetIndication.scss.css.virtualfile';
        module.exports = {"multiplePresetIndication":"_multiplePresetIndication_7a2b9_7"};